import React from "react";
import PropTypes from "prop-types";

/**
 * LoadingSkeleton
 * Skeleton loader com animação shimmer (padrão premium).
 */
const LoadingSkeleton = ({ 
    type = "text", 
    rows = 1, 
    colSize = 12, 
    height = "16px", 
    width = "100%", 
    className = "",
    style = {}
}) => {
    
    const skeletonClass = `neo-skeleton ${className}`;

    // Estilos comuns para todos os formatos
    const getStyles = (customStyle) => ({
        display: type === "text" || type === "block" ? "block" : "inline-block",
        ...customStyle,
        ...style
    });

    return (
        <React.Fragment>
            <style>{`
                .neo-skeleton {
                    background: #e2e5e8;
                    background-image: linear-gradient(
                        90deg,
                        rgba(255, 255, 255, 0) 0,
                        rgba(255, 255, 255, 0.4) 20%,
                        rgba(255, 255, 255, 0.8) 60%,
                        rgba(255, 255, 255, 0)
                    );
                    background-size: 200px 100%;
                    background-repeat: no-repeat;
                    animation: neo-shimmer 1.5s infinite linear;
                    border-radius: 4px;
                }
                
                @keyframes neo-shimmer {
                    0% {
                        background-position: -200px 0;
                    }
                    100% {
                        background-position: calc(200px + 100%) 0;
                    }
                }
            `}</style>
            
            {type === "text" && (
                <div className={className}>
                    {[...Array(rows)].map((_, i) => (
                        <span 
                            key={i} 
                            className={`${skeletonClass} col-${colSize} mb-2`} 
                            style={getStyles({ height })}
                        ></span>
                    ))}
                </div>
            )}

            {type === "circle" && (
                <div className={className}>
                    <span 
                        className={`${skeletonClass} rounded-circle`} 
                        style={getStyles({ height, width: height })}
                    ></span>
                </div>
            )}

            {type === "block" && (
                <div className={className}>
                    <span 
                        className={`${skeletonClass}`} 
                        style={getStyles({ height, width, borderRadius: '8px' })}
                    ></span>
                </div>
            )}
        </React.Fragment>
    );
};



LoadingSkeleton.propTypes = {
    type: PropTypes.oneOf(["text", "circle", "block"]),
    rows: PropTypes.number,
    colSize: PropTypes.number, // 1 to 12
    height: PropTypes.string,
    width: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object
};

export default LoadingSkeleton;
